export function normalizePackageSearchQuery(query) {
    return String(query == null ? "" : query).trim().toLowerCase();
}

export function packageSearchFieldName(field) {
    return field === "packageId" ? "packageId" : "ucc128";
}

export function readPackageField(record, field) {
    if (!record) {
        return "";
    }
    const value = typeof record.get === "function" ? record.get(field) : record[field];
    return value == null ? "" : String(value);
}

export function findFirstPackageMatchIndex(packages, field, query) {
    const needle = normalizePackageSearchQuery(query);
    if (!needle) {
        return -1;
    }
    const key = packageSearchFieldName(field);
    const list = packages || [];
    for (let index = 0; index < list.length; index += 1) {
        if (readPackageField(list[index], key).toLowerCase().indexOf(needle) !== -1) {
            return index;
        }
    }
    return -1;
}

export function areAllPackagesSelected(packages, selectedIds) {
    const list = packages || [];
    if (!list.length) {
        return false;
    }
    const selected = selectedIds || [];
    return list.every((pkg) => selected.indexOf(pkg.packageId) !== -1);
}

export function packageRowIsInLoadedRange(index, rangeStart, pageSize) {
    const start = Math.max(0, Number(rangeStart) || 0);
    const size = Number(pageSize) > 0 ? Number(pageSize) : 40;
    return index >= start && index < start + size;
}

export function packageWrapperScrollTop(index, rangeStart, rowHeight) {
    const height = Number(rowHeight) || 0;
    const start = Math.max(0, Number(rangeStart) || 0);
    if (!height || index < 0) {
        return 0;
    }
    return Math.max(0, index - start) * height;
}

export function escapePackageSearchHtml(value) {
    return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

export function renderHighlightedPackageText(value, query) {
    const text = String(value == null ? "" : value);
    const needle = String(query == null ? "" : query).trim();
    if (!needle) {
        return escapePackageSearchHtml(text);
    }
    const lowerNeedle = needle.toLowerCase();
    const lower = text.toLowerCase();
    let html = "";
    let start = 0;
    let index = lower.indexOf(lowerNeedle, start);
    if (index === -1) {
        return escapePackageSearchHtml(text);
    }
    while (index !== -1) {
        html += escapePackageSearchHtml(text.slice(start, index));
        html += '<span class="ucc128-search-match">'
            + escapePackageSearchHtml(text.slice(index, index + lowerNeedle.length))
            + "</span>";
        start = index + lowerNeedle.length;
        index = lower.indexOf(lowerNeedle, start);
    }
    html += escapePackageSearchHtml(text.slice(start));
    return html;
}
